import axiosInstance from './axiosInstance';

export const submitStudentFeedback = async (entries) => {
  const res = await axiosInstance.post('/student-feedback', { entries });
  return res.data;
};

export const fetchStudentFeedbackStats = async (params = {}) => {
  const res = await axiosInstance.get('/student-feedback/stats', { params });
  return res.data?.data;
};

export const listStudentFeedback = async (params = {}) => {
  const res = await axiosInstance.get('/student-feedback/list', { params });
  return res.data;
};

export const exportStudentFeedback = async (params = {}) => {
  const res = await axiosInstance.get('/student-feedback/export', { params, responseType: 'blob' });
  return res.data;
};


